import ReactPlayer from 'react-player';
import { CircularProgress } from '../../../MaterialUIComponents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/pro-solid-svg-icons';
import { useCallback, useState } from 'react';
import React = require('react');

interface IVideoEventCardThumbnailProps {
    eventId: number;
    displayEventId: string;
    thumbnailURL: string;
    videoURL: string;
    height?: number;
    onSelectVideoEvent: (eventId: string, goBack: boolean) => void;
    handleVideoPlayed: (eventid: number | undefined) => void;
}

const styles = require('./VideoEventCardThumbnail.scss') as {
    main: string;
    thumbnail: string;
    videoPlayer: string;
    hidePlayer: string;
    playOverlay: string;
    playIcon: string;
};

export const VideoEventCardThumbnail: React.FC<IVideoEventCardThumbnailProps> = (props) => {
    const [playing, setPlaying] = useState<boolean>(false);
    const [loadVideo, setLoadVideo] = useState<boolean>(false);
    const [loadedVideo, setLoadedVideo] = useState<boolean>(false);
    const [hasPlayed, setHasPlayed] = useState<boolean>(false);
    const [isHovered, setIsHovered] = useState<boolean>(false);

    const handlePlayPause = useCallback(() => {
        if (!hasPlayed) {
            props.handleVideoPlayed(props.eventId);
            setHasPlayed(true);
        }

        if (!loadedVideo) {
            setPlaying(true);
            setLoadVideo(true);
        } else {
            setPlaying((p) => !p);
            setHasPlayed(true);
            setIsHovered(false);
        }
    }, [hasPlayed, loadedVideo, props, props.eventId]);

    const videoLoadComplete = useCallback(() => {
        setLoadedVideo(true);
    }, []);

    const videoEnded = useCallback(() => {
        setPlaying(false);
        setLoadVideo(true);
    }, []);

    const videoUrl = props.videoURL;
    const imageUrl = props.thumbnailURL;

    return (
        <div
            className={styles.main}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            {...(props.height ? { style: { height: props.height } } : {})}
        >
            {loadVideo ? (
                <div onClick={handlePlayPause} title={playing ? 'Pause Video' : 'Play Video'}>
                    <ReactPlayer
                        url={videoUrl}
                        controls={false}
                        width="100%"
                        playing={playing}
                        className={styles.videoPlayer + (!loadedVideo ? ' ' + styles.hidePlayer : '')}
                        onReady={videoLoadComplete}
                        muted={true}
                        onEnded={videoEnded}
                        {...(props.height ? { style: { maxHeight: props.height } } : {})}
                    />
                    {!loadedVideo && (
                        <div>
                            <img className={styles.thumbnail} src={imageUrl} alt="thumbnail" />
                            <span className={styles.playOverlay}>
                                <CircularProgress />
                            </span>
                        </div>
                    )}
                </div>
            ) : (
                <img
                    className={styles.thumbnail}
                    src={imageUrl}
                    alt="thumbnail"
                    onClick={handlePlayPause}
                    {...(props.height ? { style: { height: props.height } } : {})}
                />
            )}
            <div onClick={handlePlayPause} className={styles.playOverlay} title={playing ? 'Pause Video' : 'Play Video'}>
                {!playing ? (
                    <FontAwesomeIcon icon={faPlay} className={styles.playIcon} />
                ) : (
                    isHovered && loadedVideo && <FontAwesomeIcon icon={faPause} className={styles.playIcon} />
                )}
            </div>
        </div>
    );
};
